module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "minha-conta"
  }, [_c('div', {
    staticClass: "meus-dados"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "meu-avatar",
    style: ({
      backgroundImage: 'url(' + _vm.avatar + ')'
    })
  }, [_vm._m(0), _vm._v(" "), (!_vm.avatar) ? _c('div', {
    key: "avatarSigla",
    staticClass: "user-sigla"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentUser.sigla) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.avatar) ? _c('div', {
    key: "avatarRemover",
    staticClass: "overlay-remover",
    attrs: {
      "title": "Remover Avatar"
    },
    on: {
      "click": _vm.removerAvatar
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.$refs.uploadFile.click()
      }
    }
  }, [_c('input', {
    ref: "uploadFile",
    staticClass: "upload-file",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg"
    },
    on: {
      "change": _vm.selecionaImagem
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.currentUser.pessoa.nome))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.currentUser.ref_pessoa))]), _vm._v(" "), _c('nav', {
    staticClass: "menu-conta"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'minha-conta.inicial'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Inicial")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'minha-conta.dados-cadastrais'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Editar Meus Dados")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'minha-conta.notificacoes'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Notificações e SMS")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModalAlterarSenha(false)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Alterar Senha")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "formulario"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": _vm.isMobile().any() ? '90%' : '60%'
    },
    model: {
      value: (_vm.mostrarModalSenha),
      callback: function($$v) {
        _vm.mostrarModalSenha = $$v
      },
      expression: "mostrarModalSenha"
    }
  }, [_c('v-card', {
    staticClass: "modal-alterar-senha"
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n                Alteração de Senha: " + _vm._s(_vm.tipoAlteracaoSenha === 'souurcamp' ? 'Sou URCAMP' : 'Email Acadêmico') + "\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.tipoAlteracaoSenha === 'souurcamp') ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "senhaAtual",
    attrs: {
      "type": "password",
      "error-messages": _vm.senhaAtualErros,
      "label": "Senha Atual",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.senha.senhaAtual.$touch()
      },
      "blur": function($event) {
        return _vm.$v.senha.senhaAtual.$touch()
      }
    },
    model: {
      value: (_vm.senha.senhaAtual),
      callback: function($$v) {
        _vm.$set(_vm.senha, "senhaAtual", $$v)
      },
      expression: "senha.senhaAtual"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "novaSenha",
    attrs: {
      "type": "password",
      "error-messages": _vm.senhaNovaSenhaErros,
      "label": "Nova Senha",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.senha.novaSenha.$touch()
      },
      "blur": function($event) {
        return _vm.$v.senha.novaSenha.$touch()
      }
    },
    model: {
      value: (_vm.senha.novaSenha),
      callback: function($$v) {
        _vm.$set(_vm.senha, "novaSenha", $$v)
      },
      expression: "senha.novaSenha"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "error-messages": _vm.senhaNovaSenhaConfirmacaoErros,
      "label": "Confirmação da Nova Senha",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.senha.novaSenhaConfirmacao.$touch()
      },
      "blur": function($event) {
        return _vm.$v.senha.novaSenhaConfirmacao.$touch()
      }
    },
    model: {
      value: (_vm.senha.novaSenhaConfirmacao),
      callback: function($$v) {
        _vm.$set(_vm.senha, "novaSenhaConfirmacao", $$v)
      },
      expression: "senha.novaSenhaConfirmacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.senha.$invalid || _vm.senhasDiferentes || !_vm.tipoAlteracaoSenha.length
    },
    on: {
      "click": _vm.alterarSenha
    }
  }, [_vm._v("\n                    Alterar Senha\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalSenha = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fas fa-camera"
  }), _vm._v(" "), _c('span', [_vm._v("Trocar imagem do perfil")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c5a72b8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/MinhaConta.vue
// module id = 577
// module chunks = 2